import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { FormattedMessage, InjectedIntlProps, injectIntl } from 'react-intl';
import { RouteProps } from 'react-router-dom';
import Input from '../../../components/input/input';
import DataStore from '../../store/DataStore';
import messages from '../messages';
interface IDataStore {
  dataStore?: DataStore;
}

interface IForm {
  onForceNext?: () => void;
}

const Form: React.SFC<RouteProps & IForm & IDataStore & InjectedIntlProps> = ({
  dataStore,
  intl,
  onForceNext
}) => {
  const onKeyDown = event => {
    if (event.which == 13 || event.keyCode == 13) {
      if (typeof onForceNext === 'function') onForceNext();
    }
  };
  return (
    <div className="c-bubble__content">
      <div className="c-bubble__content-text">
        <FormattedMessage {...messages.formIntro} />
      </div>

      <Input
        onKeyDown={event => onKeyDown(event)}
        onChange={event => {
          dataStore.setFirstname(event.currentTarget.value);
        }}
        value={dataStore.firstname}
        label={intl.formatMessage(messages.formLabelFirstName)}
      />
      {/* <Input
        onKeyDown={event => onKeyDown(event)}
        onChange={event => dataStore.setSurname(event.currentTarget.value)}
        value={dataStore.surname}
        label={intl.formatMessage(messages.formLabelSurname)}
      /> */}
    </div>
  );
};

export default inject('dataStore')(injectIntl(observer(Form)));



// WEBPACK FOOTER //
// ./src/containers/start/components/Form.tsx